<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-data-table
                :headers="headers"
                :items="offers"
                class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Товары</v-toolbar-title>
                </v-toolbar>
            </template>
            <template v-slot:item.name="{ item }">
                {{ item.product.shortDescription }}
            </template>
            <template v-slot:item.category="{ item }">
                <!--{{ getCategoryById(+item['@attributes'].id).name }}-->
            </template>
            <template v-slot:item.count="{ item }">
                {{ item.count }}
            </template>
            <template v-slot:item.summary="{ item }">
                {{ item.count * item.product.price }}
            </template>
            <template v-slot:footer>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                        Итого по товарам: {{(orderModel.price + orderModel.discount) + currency}}<br>
                        Доставка: {{delivery.price + currency}}<br>
                        <div v-show="promo != null">Промо ({{promo != null ? promo.code : ''}}) : {{saleSize + currency}}<br></div>
                        Итого: {{orderModel.price + currency}}<br>
                        Оплачено баллами: {{orderModel.discount + currency}}
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import axios from 'axios'
import constconf from '@/constconf'
export default {
    name: 'OfferTable',
    props: ['orderModel', 'delivery'],
    data() {
        return {
            categories: [],
            offers: [],
            headers: [
                {
                    text: 'Название',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Категория',
                    sortable: false,
                    value: 'category'
                },
                { text: 'Цена', value: 'price' },
                { text: 'Количество', value: 'count' },
                { text: 'Сумма', value: 'summary' },
                { text: ' ', value: 'action' }
            ],
            saleSize: 0,
            promo: null,
            currency: ' руб.'
        }
    },
    watch: {
        orderModel: {
            handler(value) {
                if (value) {
                    this.loadOffers()
                    this.show = value
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        loadOffers() {
            axios.post(constconf.shop.url + '/catalog/get-offers-by-order/' + this.orderModel.id).then(response => {
                if (response.data.ok) {
                    this.offers = response.data.response.data
                    this.categories = response.data.response.categories
                }
            })
            axios.post(constconf.shop.url + '/catalog/get-sale-size/' + this.orderModel.id).then(response => {
                if (response.data.ok) {
                    this.saleSize = response.data.response.data
                    this.promo = response.data.response.promo
                }
            })
        },
        getCategoryById(id) {
            return this.categories.find(category => category.id === id)
        },
        getCountByIndex(id) {
            console.log(this.orderModel.cards)
            return this.orderModel.cards.find(offer => +offer[0] === id)[1]
        },
        getFullNameById(item) {
            let fullName = item.name
            if (item.hasOwnProperty('weight')) {
                fullName += ' | Вес: ' + item.weight
            }
            return fullName
        },
        getSumForOffers() {
            let sum = 0
            for (let i = 0; i < this.offers.length; i++) {
                sum += this.offers[i].price * this.getCountByIndex(+this.offers[i]['@attributes'].id)
            }
            return sum
        }
    },
    created() {
        this.headers[2].text = 'Стоимость, ' + 'руб.'
        this.headers[4].text = 'Сумма, ' + 'руб.'
    }
}
</script>

<style scoped>

</style>
